export default "__VITE_ASSET__VgLp$UBR__"